<form #projectForm="ngForm" class="info-form">
  <div class="base-info-block">
    <div class="project-info row-block name-block">
      <div class="project-label">
        Name:
      </div>
      <div class="project-span">
        <input pInputText BlockLateralArrowNavigation class="text-input" autocomplete="off" placeholder="Project Name"
               type="text"
               [(ngModel)]="project.name" name="name">
      </div>
    </div>
    <div class="project-info row-block manager-block">
      <div class="project-label">
        Manager:
      </div>
      <div class="project-span">
        <app-project-manager-edit [managerId]="project.projectManager?.id"></app-project-manager-edit>
      </div>
    </div>

    <div class="project-info row-block search-block">
      <div class="project-label">
        Customer:
      </div>
      <div class="project-span">
        <app-customer-search [projectId]="project.id" [customer]="project.customer"
                             [nfsContacts]="project.notificationContacts"></app-customer-search>
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Location:
      </div>
      <div class="project-span location-block">
        <input pInputText BlockLateralArrowNavigation #locationInput class="text-input" autocomplete="off"
               placeholder="Location"
               type="text" [(ngModel)]="project.location" name="location">

        <div class="direction-icon" *ngIf="project?.location" (click)="mapOp.toggle($event)">
          <mat-icon>more_vert</mat-icon>

          <p-overlayPanel #mapOp appendTo="body" class="location-overlay-panel">
            <div class="map-overlay">
              <div class="menu-button" (click)="openMap()">
                <mat-icon>directions</mat-icon>
                <div class="menu-label">Open in Map</div>
              </div>
              <div class="menu-button" [class.disabled]="!navigatorHasShare" (click)="shareLocation()">
                <mat-icon>share</mat-icon>
                <div class="menu-label">Share</div>
              </div>
              <div class="menu-button" (click)="copyLink(locationInput)">
                <mat-icon>file_copy</mat-icon>
                <div class="menu-label">{{copyLabel}}</div>
              </div>
            </div>
          </p-overlayPanel>
        </div>
      </div>
    </div>
    <div class="project-info row-block due-date-block">
      <div class="project-label">
        Due Date:
      </div>
      <div class="project-span">
        <app-due-date [project]="project"></app-due-date>
      </div>
    </div>

  </div>
  <div class="labels-block">
    <div class="project-info row-block">
      <div class="project-label">
        Type:
      </div>
      <div class="complexity-span project-span">
        <app-project-type-edit #projectTypeDropdown [statusId]="project.type?.id"></app-project-type-edit>
      </div>
    </div>
    <!-- TODO DON'T FORGET. NGIF IN FINISH VENDOR COMPONENT -->
    <div class="project-info row-block search-block vendor-block"
         *ngIf="project.type?.name === 'InHouseFinishing' || project.type?.name === 'OrderFinishing'">
      <div class="project-label">
        Finish. Vendor:
      </div>
      <div class="project-span">

        <app-finish-vendor-search [project]="project" [vendorId]="project.finishingVendor?.id">
        </app-finish-vendor-search>
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Complexity:
      </div>
      <div class="complexity-span project-span">
        <app-complexity-edit [jobComplexity]="project?.jobComplexity"
                             [manualComplexity]="project?.complexityChangedManually"
                             [complexityHrs]="project?.overallComplexity"></app-complexity-edit>
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Project Status:
      </div>
      <div class="complexity-span project-span">
        <app-project-status-edit [cardId]="project?.card?.id" [columnId]="project.card?.list?.id">
        </app-project-status-edit>
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Docu. Status:
      </div>
      <div class="complexity-span project-span">
        <app-docusign-status-edit [status]="project.docuSignStatus"></app-docusign-status-edit>
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Cab. Pmnt:
      </div>
      <div class="complexity-span project-span">
        <app-payment-status-edit [status]="project.paymentStatus"></app-payment-status-edit>
      </div>
      <div class="status-indicator"
           style.background-color="#{{project.paymentStatus.color ? project.paymentStatus.color : 'FFF'}}">
      </div>
    </div>
    <div class="project-info row-block">
      <div class="project-label">
        Install. Pmnt:
      </div>
      <div class="complexity-span project-span">
        <app-install-pmnt-status-edit [status]="project.installationPaymentStatus"></app-install-pmnt-status-edit>
      </div>
    </div>
    <!--    We discussed to get rid of approved button-->

    <!--    <div class="project-info row-block">-->
    <!--      <div class="project-label">-->
    <!--        Drawing Approved:-->
    <!--      </div>-->
    <!--      <div class="drawapprove-span project-span">-->
    <!--        <app-drawing-approved-status-edit [inputStatus]="project.drawingApproved">-->
    <!--        </app-drawing-approved-status-edit>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</form>
